export default __webpack_public_path__ + "static/media/3-star.95baf964.svg";